import { useQuery } from "@tanstack/react-query";

import { PublicInformation } from "helpers/queriesDataKeys";
import { API_BASE_URL } from "configs/AppConfig";

import NavList from "./NavList";

import styles from "./Footer.module.css";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ContactInfo from "./ContactInfo";
import ProductsServices from "./ProductsServices";
import KeyEnablers from "./KeyEnablers";
import ConsultUs from "./ConsultUs";

const FaqList = [{ name: "FAQ", to: "/faq" }];
const ConnectNavList = [{ name: "Contact Us", to: "/contact-us" }];

const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { widgets } = useSelector((state) => state.constants);
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState([]);
  const [keyEnablers, setKeyEnablers] = useState([]);
  const { settings } = useSelector((state) => state.constants);

  useEffect(() => {
    if (widgets?.length > 0) {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [widgets]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const fetchData = async () => {
    try {
      const [headerRes, footerRes] = await Promise.all([
        fetch(
          `${API_BASE_URL}pages/get/all?category=6708c40b5e9b4984e1e22139&page=1&limit=6&homeHeaderOrder=true`,
          {
            headers: { "Content-Type": "application/json" },
          }
        ),
        fetch(
          `${API_BASE_URL}pages/get/all?category=6708c40b5e9b4984e1e22139&page=1&limit=3&homeFooterOrder=true`,
          {
            headers: { "Content-Type": "application/json" },
          }
        ),
      ]);

      const [headerData, footerData] = await Promise.all([
        headerRes.json(),
        footerRes.json(),
      ]);

      if (!headerRes.ok) throw new Error(headerData.message);

      if (headerData?.success) {
        const headerMenu = headerData.data?.map((item) => ({
          name: item?.name,
          path: `/pages/${item?.slug}`,
        }));
        setServices(headerMenu);
      }

      if (footerData?.success) {
        const footerMenu = footerData.data?.map((item) => ({
          name: item?.name,
          path: `/pages/${item?.slug}`,
        }));
        setKeyEnablers(footerMenu);
      }

      console.log("Header Data:", headerData);
      console.log("Footer Data:", footerData);
    } catch (error) {
      console.error("Error fetching pages:", error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {/* {widgets?.length > 0 && !loading && (
        <> */}
      <section className={styles.container}>
        <div className={styles.section}>
          <div className={styles.contactWrapper}>
            <div className={styles.contactContent}>
              <header className={styles.headerWrapper}>
                <h2 className={styles.heading}>
                  <div
                    data-aos="fade-left"
                    data-aos-delay="200"
                    className={styles.headingText}
                  >
                    Contact us for a free assessment
                  </div>
                  <div className={styles.headingUnderline} />
                </h2>
                <div className={styles.headingUnderline2} />
              </header>
              <button
                data-aos="fade-down"
                data-aos-delay="200"
                className={styles.ctaButton}
              >
                <span
                  className={styles.ctaText}
                  onClick={() => navigate("/contact-us")}
                >
                  GET FREE ASSESSMENT
                </span>
                <img
                  src="/img/bodyshop/white-arrow.svg"
                  alt=""
                  className={styles.ctaIcon}
                />
              </button>
            </div>
          </div>
        </div>
        <div className={styles.infoSection}>
          <div className={styles.infoWrapper}>
            <div className={styles.infoContent}>
              <div className={styles.infoColumns}>
                <ContactInfo settings={settings} />
                <ProductsServices services={services} />
                <KeyEnablers keyEnablers={keyEnablers} />
                <ConsultUs settings={settings} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.footerBottom}>
        <p>
          Copyright Wedding © {new Date().getFullYear()} v1.1.6. All rights
          reserved | Developed By{" "}
          <span
            style={{ cursor: "pointer" }}
            onClick={() => window.open("https://riolabz.com/", "_blank")}
          >
            Riolabz
          </span>
          . All rights reserved.
        </p>
      </div>
      {/* </>
      )} */}
    </>
  );
};

export default Footer;
